/**
 * Centralized design tokens aligned with Dewatanet brand palette
 * 
 * Brand Colors:
 * - Vivid Red (#DC2626): Energi, keberanian, semangat dinamis
 * - Deep Grey/Charcoal (#1F2937): Stabilitas, profesionalisme, pondasi kokoh
 * - Solid Black (#0A0A0B): Keterbacaan, kesan elegan, otoritas
 * - White (#FFFFFF): Bersih, modern, negative space
 */

export const brand = {
  // Dewatanet Core Palette
  vividRed: '#DC2626',
  deepGrey: '#1F2937',
  solidBlack: '#0A0A0B',
  white: '#FFFFFF',

  // Extended Red Scale (from Vivid Red)
  red50:  '#FEF2F2',
  red100: '#FEE2E2',
  red200: '#FECACA',
  red300: '#FCA5A5',
  red400: '#F87171',
  red500: '#EF4444',
  red600: '#DC2626',   // Primary — Vivid Red
  red700: '#B91C1C',
  red800: '#991B1B',
  red900: '#7F1D1D',

  // Extended Grey Scale (from Deep Grey)
  grey50:  '#F9FAFB',
  grey100: '#F3F4F6',
  grey200: '#E5E7EB',
  grey300: '#D1D5DB',
  grey400: '#9CA3AF',
  grey500: '#6B7280',
  grey600: '#4B5563',
  grey700: '#374151',
  grey800: '#1F2937',  // Secondary — Deep Grey/Charcoal
  grey900: '#111827',

  // Semantic Colors  
  primary: '#DC2626',    // Vivid Red
  success: '#059669',    // Emerald 600
  warning: '#D97706',    // Amber 600
  danger: '#DC2626',     // Vivid Red (same as primary for destructive)
  info: '#2563EB',       // Blue 600
  surface: '#FFFFFF',    // White background
};

export const palette = {
  light: {
    backgroundDefault: '#F9FAFB',       // Grey 50
    backgroundPaper: '#FFFFFF',
    textPrimary: '#0A0A0B',             // Solid Black
    textSecondary: '#4B5563',           // Grey 600
    divider: 'rgba(0,0,0,0.06)',
    accent: '#DC2626',                  // Vivid Red
    cardBg: '#FFFFFF',
    cardBorder: '#E5E7EB',
  },
  dark: {
    backgroundDefault: '#0A0A0B',       // Solid Black
    backgroundPaper: '#1F2937',         // Deep Grey
    textPrimary: '#F9FAFB',
    textSecondary: '#9CA3AF',
    divider: 'rgba(255,255,255,0.06)',
    accent: '#F87171',                  // Red 400 (lighter for dark mode)
    cardBg: '#1F2937',
    cardBorder: '#374151',
  },
};

export const shape = {
  borderRadius: 12,
  buttonRadius: 10,
  paperRadius: 16,
  chipRadius: 8,
};

export const typography = {
  fontFamily: [
    'Inter',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Helvetica Neue',
    'Arial',
    'Noto Sans',
    'sans-serif',
  ].join(','),
  buttonWeight: 700,
  buttonWeightAlt: 600,
};

export const gradients = {
  primary: `linear-gradient(135deg, ${brand.vividRed} 0%, #F87171 100%)`,
  dark: `linear-gradient(135deg, ${brand.solidBlack} 0%, ${brand.deepGrey} 100%)`,
  success: `linear-gradient(135deg, ${brand.success} 0%, #34D399 100%)`,
  warning: `linear-gradient(135deg, ${brand.warning} 0%, #FBBF24 100%)`,
  danger: `linear-gradient(135deg, ${brand.vividRed} 0%, #EF4444 100%)`,
  glass: `linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)`,
  heroLight: `linear-gradient(135deg, #0A0A0B 0%, #1F2937 60%, #DC2626 100%)`,
  heroDark: `linear-gradient(135deg, #0A0A0B 0%, #1F2937 80%, #991B1B 100%)`,
};

export const colors = { ...brand };
